
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalog/[group1]",
      function () {
        return require("private-next-pages/catalog/[group1].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalog/[group1]"])
      });
    }
  